import store from '@/store'

export default [
	{
		path: '/comments',
		name: 'comment',
		meta: { requiresAuth: true },
		component: () => import('@/pages/comment/form.vue'),
		beforeEnter: async (to, from, next) => {
			next()
		}
	},
	{
		path: '/comments/:id',
		name: 'comment-edit',
		meta: { requiresAuth: true },
		component: () => import('@/pages/comment/form.vue'),
		beforeEnter: async (to, from, next) => {
			await store.dispatch('comment/find', to.params.id)
			next()
		}
	}
]
